import { http } from "./http";

export type InvitationLogEstado = "ENVIADO" | "FALLIDO" | string;

export type InvitationLog = {
  canal: string;
  enviadoEn: string;
  errorDetalle: string | null;
  estado: InvitationLogEstado;
  eventoId: number;
  id: number;
  invitado: {
    apellido: string;
    id: number;
    nombre: string;
    telefono: string | null;
  };
  mensaje: string;
  modo: string;
};

export async function listarLogsInvitacionesPorEvento(eventoId: number) {
  return http.request<InvitationLog[]>(`/api/admin/logs-invitaciones/evento/${eventoId}`, {
    method: "GET",
  });
}
